module.exports = __webpack_public_path__ + "img/after2.7435e3a3.jpg";